import { create } from 'zustand'

interface DevtoolsStore {
  showQueryDevtools: boolean
  showRouterDevtools: boolean
  setShowQueryDevtools: (value: boolean) => void
  setShowRouterDevtools: (value: boolean) => void
}

export const useDevtoolsStore = create<DevtoolsStore>()((set) => ({
  showQueryDevtools: false,
  showRouterDevtools: false,
  setShowQueryDevtools: (value) => set({ showQueryDevtools: value }),
  setShowRouterDevtools: (value) => set({ showRouterDevtools: value }),
}))
